import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import "./styles/button_styles.css"; // ✅ Ensure global styles are loaded
//import "tailwindcss/tailwind.css"; // ✅ Ensure Tailwind is loaded

const root = ReactDOM.createRoot(document.getElementById('root'));

//<React.StrictMode> ... </React.StrictMode>
root.render(
//  <React.StrictMode> 
    <App />
//    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
